import { render } from "./Projects.vue?vue&type=template&id=32e88062"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__